import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _IconBot;
const _excluded = ["sx", "children", "variant"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import { getInitials } from '@lumahealthhq/ui-utils';
import { extendSX } from '../helpers';
import { useStringToColor } from '../hooks';
import { IconBot } from '../icons';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Avatar](https://ui-packages.isbuildingluma.com/ui-core/react-avatar/)
 *
 * API:
 *
 * - [Avatar API](https://ui-packages.isbuildingluma.com/ui-core/api/avatar/)
 * - inherits [MuiAvatar API](https://mui.com/material-ui/api/avatar/)
 */
const Avatar = /*#__PURE__*/React.forwardRef(function Avatar(_ref, ref) {
  let {
      sx,
      children,
      variant
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const initials = React.useMemo(() => {
    if (variant !== 'bot' && typeof children === 'string') {
      return getInitials(children);
    }
    return undefined;
  }, [variant, children]);
  const backgroundColor = useStringToColor(initials);
  return /*#__PURE__*/_jsx(MuiAvatar, _extends({
    ref: ref,
    sx: extendSX(sx, [!!initials && {
      backgroundColor
    }, (variant === 'bot' || variant === 'staff') && {
      bgcolor: 'grey.100',
      color: 'primary.main'
    }])
    // Casting because we want to avoid using `AvatarPropsVariantOverrides`
    // https://mui.com/material-ui/customization/theme-components/#creating-new-component-variants
    ,
    variant: variant
  }, rest, {
    children: initials || variant === 'bot' && (_IconBot || (_IconBot = /*#__PURE__*/_jsx(IconBot, {}))) || children
  }));
});
process.env.NODE_ENV !== "production" ? Avatar.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "AvatarProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: PropTypes.oneOf(['bot', 'circular', 'rounded', 'square', 'staff'])
} : void 0;
export default Avatar;